const accessReport = {

    FARM_REPORT: {
        path: '/farm-report'
    },

    CROP_PLANING_REPORT: {
        path: '/crop-planing-report'
    },

    CROP_PLANING_STATUS: {
        path: '/crop-planing-status'
    },

    CONSTRUCTION_REPORT: {
        path: '/construction-report'
    },

}

export default accessReport;